import { useForm } from '@inertiajs/react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  formationId: string
}

export function StateFilingDialog({ open, onOpenChange, formationId }: Props) {
  // Nested explicitly rather than left to Rails' param-wrapping — see
  // RegisteredAgentAddressDialog for why relying on that inference is fragile.
  const { data, setData, post, processing, errors, reset, clearErrors } = useForm({ state_filing: { jurisdiction_reference: '' } })

  function handleClose(success: boolean) {
    onOpenChange(false)
    if (!success) {
      reset()
      clearErrors()
    }
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post(`/backoffice/formations/${formationId}/state_filing`, {
      onSuccess: () => handleClose(true)
    })
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-full sm:max-w-md overflow-y-auto">
        <DialogHeader className="mb-6">
          <DialogTitle>Record state filing</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4 px-4">
          <div className="space-y-2">
            <Label htmlFor="jurisdiction_reference">
              Filing reference <span className="text-destructive">*</span>
            </Label>
            <Input
              id="jurisdiction_reference"
              placeholder="e.g. WY-2026-00456"
              value={data.state_filing.jurisdiction_reference}
              onChange={(e) => setData('state_filing', { jurisdiction_reference: e.target.value })}
              required
            />
            {errors['state_filing.jurisdiction_reference'] && (
              <p className="text-sm text-destructive">{errors['state_filing.jurisdiction_reference']}</p>
            )}
          </div>

          <p className="text-xs text-muted-foreground">
            Marks this formation as filed with the Secretary of State, submitted today, and emails the founder.
          </p>

          <div className="sticky bottom-0 bg-background border-t p-4 -mx-4 mt-8">
            <div className="flex gap-3">
              <Button type="button" variant="outline" className="flex-1" onClick={() => handleClose(false)}>
                Cancel
              </Button>
              <Button type="submit" className="flex-1" disabled={processing}>
                {processing ? 'Recording...' : 'Record filing'}
              </Button>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  )
}
